import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import SidebarSectionTitle from '../../react-components/SidebarSectionTitle/SidebarSectionTitle';

const propTypes = {
  exchangeCriteria: PropTypes.string.isRequired,
  optionDisabledLabel: PropTypes.string.isRequired,
  language: PropTypes.object.isRequired,
  selectedOptions: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  exchangeOptions: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  hideUnavailable: PropTypes.bool,
  clearable: PropTypes.bool,
};

const defaultProps = {
  disabled: false,
  hideUnavailable: false,
  clearable: false,
};

const ReturnsSelect = ({
  exchangeCriteria,
  exchangeOptions,
  language,
  optionDisabledLabel,
  hideUnavailable,
  onChange,
  onFocus,
  selectedOptions,
  disabled,
  clearable,
}) => {
  const buildOptions = () => {
    const attributeCatalog = exchangeOptions[exchangeCriteria];
    const sortedAttributeList = exchangeOptions[`${exchangeCriteria}SortOrder`];

    if (hideUnavailable) {
      return sortedAttributeList
        .filter((attribute) => attributeCatalog[attribute])
        .map((attribute) => ({
          value: attribute,
          label: attribute,
          disabled: !attributeCatalog[attribute],
        }));
    }

    return sortedAttributeList.map((attribute) => ({
      value: attribute,
      label: `${attribute} ${
        attributeCatalog[attribute]
          ? ''
          : ` ${language[`returns.step_1.exchange.${optionDisabledLabel}`]}`
      }`,
      disabled: !attributeCatalog[attribute],
    }));
  };

  return (
    <div data-test={`select-exchange-attribute-${exchangeCriteria}`}>
      <SidebarSectionTitle
        index={0}
        title={language[`returns.exchange.clothes.${exchangeCriteria}`]}
      />
      <Select
        autoBlur
        disabled={disabled}
        name="returns-select"
        value={selectedOptions[exchangeCriteria] || ''}
        onChange={onChange}
        onFocus={onFocus}
        placeholder={`${language[`returns.exchange.clothes.${exchangeCriteria}.dropdown_label`]}`}
        options={buildOptions()}
        clearable={clearable}
      />
    </div>
  );
};

ReturnsSelect.defaultProps = defaultProps;
ReturnsSelect.propTypes = propTypes;
export default ReturnsSelect;
